import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TopicDrawerSkeleton = () => (
  <Styles.Container>
    <Styles.Row data-testid="topic-drawer-skeleton-row">
      <Skeleton variant="text" width="80%" height={16} />
      <Skeleton variant="text" width="40%" height={14} />
    </Styles.Row>
    <Styles.Row data-testid="topic-drawer-skeleton-row">
      <Skeleton variant="text" width="70%" height={16} />
      <Skeleton variant="text" width="35%" height={14} />
    </Styles.Row>
    <Styles.Row data-testid="topic-drawer-skeleton-row">
      <Skeleton variant="text" width="90%" height={16} />
      <Skeleton variant="text" width="30%" height={14} />
    </Styles.Row>
  </Styles.Container>
)

export default TopicDrawerSkeleton
